import axios from 'axios';


export default {
  getClients () {
    return axios.get(`/export/clients`, { responseType: 'blob' })
      .then(response => response.data);
  },
  getMachines () {
    return axios.get(`/export/machines`, { responseType: 'blob' })
      .then(response => response.data);
  },
  getWines () {
    return axios.get(`/export/wines`, { responseType: 'blob' })
      .then(response => response.data);
  },
  getProducers () {
    return axios.get(`/export/producers`, { responseType: 'blob' })
      .then(response => response.data);
  },
  getOverview (period, period_from, period_to) {
    return axios.get(`/export/overview/general`, { responseType: 'blob', params: { period, period_from: period_from.toISOString(), period_to: period_to.toISOString() } })
      .then(response => response.data);
  },
  getOverviewWine (period, period_from, period_to, client_id = null, producer_id = null) {
    return axios.get(`/export/overview/wine`, { responseType: 'blob', params: { period, period_from: period_from.toISOString(), period_to: period_to.toISOString(), client_id, producer_id } })
      .then(response => response.data);
  },
  getOverviewMachine (period, period_from, period_to, client_id = null) {
    return axios.get(`/export/overview/machine`, { responseType: 'blob', params: { period, period_from: period_from.toISOString(), period_to: period_to.toISOString(), client_id } })
      .then(response => response.data);
  }
};
